export function getDashboardDataState({
  hasUser,
  insightsLoading,
  notificationsRequired,
  notificationsReady,
  fieldTasksRequired,
  fieldTasksReady,
  propertyCount,
}) {
  const loading = !hasUser
    || insightsLoading
    || (notificationsRequired && !notificationsReady)
    || (fieldTasksRequired && !fieldTasksReady);

  if (loading) return 'loading';
  return Number(propertyCount) > 0 ? 'loaded' : 'empty';
}
